const ITEMS = [
  "WORK PERMIT VISA",
  "VISITOR VISA",
  "STUDENT VISA",
  "FAMILY / SPOUSE VISA",
  "BUSINESS VISA",
  "DOCUMENTATION ASSISTANCE",
  "IMMIGRATION CONSULTATION",
];

const Marquee = ({ dark = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-5 border-y ${
        dark ? "bg-navy-deep border-white/5" : "bg-gold border-gold-dark"
      }`}
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span
            key={i}
            className={`flex items-center font-display text-sm sm:text-base font-bold tracking-[0.25em] ${
              dark ? "text-slate-500" : "text-navy-deep"
            }`}
          >
            <span className="px-6">{item}</span>
            <span className={`h-1.5 w-1.5 rotate-45 ${dark ? "bg-gold/50" : "bg-navy-deep/60"}`} />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
